import { useState } from 'react'
import { CircularProgress } from '@mui/material'
import { Overlay } from './NeutralPageLoader.style'

const SPINNER_SIZE = 100

const MUI_SPINNER_CYCLE_MS = 1400

const NeutralPageLoader = () => {
  // A new loader is mounted at every loading step. Starting each at the clock's
  // point of the cycle makes them look like one spinner instead of restarting.
  const [animationDelay] = useState(
    () => `-${Date.now() % MUI_SPINNER_CYCLE_MS}ms`
  )

  return (
    <Overlay>
      <CircularProgress
        size={SPINNER_SIZE}
        color="inherit"
        sx={{
          animationDelay,
          '& .MuiCircularProgress-circle': { animationDelay },
        }}
      />
    </Overlay>
  )
}

export default NeutralPageLoader
